import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = Parameters<typeof DigiobcanApi.adminGetAiDecisionsStats>[0];

export const adminGetAiDecisionsStats = createQueryFn(
  QueryNameSpace.adminGetAiDecisionsStats,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    return DigiobcanApi.adminGetAiDecisionsStats(params);
  },
);
